/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getNewSingleValue(_ref) {
  var id = _ref.id,
    value = _ref.value,
    _ref$toggle = _ref.toggle,
    toggle = _ref$toggle === void 0 ? true : _ref$toggle;
  if (value == null) {
    return id;
  }
  if (toggle) {
    return id === value ? null : id;
  }
  return id;
}
var _default = getNewSingleValue;
exports.default = _default;